import React, { useEffect, useState, useMemo } from "react";
import Banner from "src/assets/images/website-images/life-health-package-banner.png";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import TabProduct from "src/Components/WebsiteComponents/TabProduct";
import { useNavigate } from "react-router-dom";
import { convertToKebabCase } from "src/helpers/helperFunctions";
import { ImageBaseUrl, QueryPath } from "src/lib/constans";

const AllLabTestsPage = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchPackages = async () => {
    if (data.length === 0) {
      setLoader(true);
    }
    const { res, err } = await httpRequest<{ result: any[] }>({
      path: "/diagnostic-product/categories/all",
    });
    if (res) {
      setData(res.result.map((item) => ({
        id: item._id,
        name: item.name,
        image:  item.image,
      })) || []);
    } else {
      toast(err, { type: "error" });
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  // Memoize the rendered cards to prevent unnecessary re-renders
  const renderedCards = useMemo(() => {
    if (loader) {
      return Array.from({ length: 12 }).map((_, index) => (
        <TabProduct key={`Skeleton-${index}`} skeleton />
      ));
    }
    return data.map((item, index) => (
      <TabProduct
        id={`lab-${item.id}`}
        key={"Product" + index}
        data={item}
        onClick={() => {
          navigate(
            `/diagnostic-products?${QueryPath.labTestCategory}=${item.id}&${QueryPath.labTestCategoryName}=${encodeURIComponent(item.name)}`,
          );
        }}
      />
    ));
  }, [loader, data]);

  return (
    <div className="bg-banner-white-image w-full h-full relative 2xl:p-4 p-2">
      <div className="view-area-width mx-auto box-design bg-white flex flex-col 2xl:gap-6 gap-4 2xl:p-4 p-2">
        <img
          src={Banner}
          alt="Banner"
          className="w-full max-h-[44vh] object-cover box-design rounded-lg"
          loading="lazy"
        />
        <div className="grid grid-cols-1  lg:grid-cols-5 2xl:grid-cols-6 gap-4">
          {renderedCards}
        </div>
      </div>
    </div>
  );
};

export default AllLabTestsPage;
